import React from "react";
import { currencyFormatter } from "../../../../_metronic/_helpers";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import BusinessIcon from "@material-ui/icons/Business";
import CallSplitIcon from "@material-ui/icons/CallSplit";
import MoneyIcon from "@material-ui/icons/Money";

export default function TotalDataCountWidget({ dataCount = {} }) {
  return (
    <>
      <div className="row">
        <div className="col">
          <div className="mt-5 row">
            {/* <div className="col-5">
              <Card>
                <CardBody>
                  <h3 className="h3">Total Penerimaan Bulan Ini</h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">
                      {currencyFormatter(
                        dataCount.total_donation_amount,
                        { decimalSeparator: "" },
                        false
                      )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </div> */}
            <div className="col-lg-6 col-md-6 col-sm-12">
              <Card style={{height: '150px'}}>
                <CardBody>
                  <h3 className="h3">
                    <PeopleAltIcon className="mr-1" />
                    Total Donatur
                  </h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">{dataCount.total_donor}</div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-6 col-md-6 col-sm-12">
              <Card style={{height: '150px'}}>
                <CardBody>
                  <h3 className="h3">
                    <PersonAddIcon className="mr-1" />
                    Penambahan Donatur
                    <br />{" "}
                    <span className="h6 text-muted">(1 Bulan Terakhir)</span>
                  </h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">{dataCount.total_new_donor}</div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="row">
            <div className="col-lg-4 col-md-4 col-sm-12">
              <Card>
                <CardBody>
                  <h3 className="h3">
                    <BusinessIcon className="mr-1" />
                    Program
                  </h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">{dataCount.total_program}</div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <Card>
                <CardBody>
                  <h3 className="h3">
                    <CallSplitIcon className="mr-1" />
                    Proyek
                  </h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">{dataCount.total_project}</div>
                  </div>
                </CardBody>
              </Card>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-12">
              <Card>
                <CardBody>
                  <h3 className="h3">
                    <MoneyIcon className="mr-1" /> Jenis Dana
                  </h3>
                  <div className="d-flex justify-content-end">
                    <div className="h1 m-5">{dataCount.total_fund_type}</div>
                  </div>
                </CardBody>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
